import { createLazyFileRoute } from "@tanstack/react-router";

import { EditResultPage } from "@/features/admin/routes/ResultEdit";

export const Route = createLazyFileRoute("/_auth/admin/results/$id/edit")({
  component: () => {
    const params = Route.useParams();
    return <EditResultPage value={decodeURIComponent(params.id)} />;
  },
});
